interface Props {
  t: (key: string) => string;
}

const CTA_URL = 'https://wa.me/5519997391955';

export function Hero({ t }: Props) {
  return (
    <section className="hero" id="top">
      <div className="hero-orb"></div>
      <div className="container hero-inner">
        <span className="tag reveal">
          <span className="mono">{t('hero.tag')}</span>
        </span>

        <h1 className="h1 reveal">
          {t('hero.h1.a')} <span className="em">{t('hero.h1.em')}</span>
        </h1>

        <p className="lead reveal">{t('hero.lead')}</p>

        <div className="hero-foot reveal">
          <a className="btn btn-primary" href={CTA_URL} target="_blank" rel="noopener noreferrer">
            {t('hero.cta')} <span className="arr">→</span>
          </a>
          <span className="meta mono">{t('hero.meta')}</span>
        </div>
      </div>
    </section>
  );
}
